export const PRODUCT_REQUEST="PRODUCT_REQUEST";
export const PRODUCT_FAILURE="PRODUCT_FAILURE";
export const PRODUCT_SUCCESS="PRODUCT_SUCCESS";
export const SINGLE_PRODUCT_SUCCESS="SINGLE_PRODUCT_SUCCESS";

export const AUTH_SUCCESS="AUTH_SUCCESS"
export const AUTH_FAILURE="AUTH_FAILURE"
export const AUTH_ALL_USER_DATA=" AUTH_ALL_USER_DATA"
export const AUTH_LOGOUT_SUCCESS="AUTH_LOGOUT_SUCCESS"
export const AUTH_ADD_NEW_USER_DATA="AUTH_ADD_NEW_USER_DATA"
export const ADMIN_CHECK="ADMIN_CHECK"

export const ADD_CART_PRODUCT_SUCCESS="ADD_CART_PRODUCT_SUCCESS"